
export const preciseRound = (val : number, decimals : number = 2) => +(Math.round(+(val + "e+" + decimals))  + "e-" + decimals);

export const meanAverage = (numerator : number, denominator : number, decimals = 2, NaNReplacement = 0) => {
    if(denominator === 0) return NaNReplacement;
    const average = numerator / denominator;
    return preciseRound(average, decimals);
}